import { Component } from '@angular/core';

import { HttpErrorStatuses } from '~shared/modules/error-handler';

@Component({
  selector: 'app-search-not-found',
  styleUrls: ['./not-found.component.scss'],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  errorStatus = HttpErrorStatuses.NotFound;
}
